module.exports = __webpack_public_path__ + "img/fig02.30ee9cac.jpg";